'use client';

import { datadogRum } from '@datadog/browser-rum';
import { cx } from '@repo/pandacss/styled-system/css';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { triggerStyles } from './constants';
import { type MoreInfoDialogProps } from './types';

const MoreInfoDialogContent = dynamic(() => import('./MoreInfoDialogContent'));

export function MoreInfoDialog(props: MoreInfoDialogProps) {
  const fallback = (
    <button type="button" className={cx(triggerStyles, props.triggerClassName)}>
      {props.children}
    </button>
  );
  return (
    <ErrorBoundary
      fallback={fallback}
      onError={error => {
        datadogRum.addError(error, {
          message: 'An error occurred while loading MoreInfoDialog. Rendering fallback.',
        });
      }}
    >
      <Suspense fallback={fallback}>{<MoreInfoDialogContent {...props} />}</Suspense>
    </ErrorBoundary>
  );
}
